import React, { useState, useEffect } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import { API_URL } from "../../../../constants/index";
import moment from "moment";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";

const HRAttendanceApproval = () => {
  const [monthsOpt, setMonthsOpt] = useState([]);
  const [empOpt, setEmpOpt] = useState([]);
  const [attendanceMonths, setAttendanceMonths] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState({});
  const [modalData, setModalData] = useState(null);
  const [selectedEmployeeName, setSelectedEmployeeName] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  const [showApproval, setShowApproval] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState();
  const [remarks, setRemarks] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [clicked, setClicked] = useState(false);
  const [initialStatuses, setInitialStatuses] = useState([]);
  const filteredData = Object.entries(attendanceData || {});
  const [remarkErrors, setRemarkErrors] = useState({});
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const totalPages = Math.ceil(filteredData.length / selectedRecordsPerPage);
  const startIndex = (currentPage - 1) * selectedRecordsPerPage;
  const endIndex = Math.min(
    startIndex + selectedRecordsPerPage,
    filteredData.length
  );
  const currentData = filteredData.slice(startIndex, endIndex);
  useEffect(() => {
    if (monthsOpt.length > 0) {
      fetchAttendanceDetails();
    }
  }, [monthsOpt]); // Make sure monthsOpt is in the dependency array

  const [apiStatus, setApiStatus] = useState("");
  const fetchAttendanceDetails = async (
    monthValue = monthsOpt[0]?.value,
    employeeId = 0
  ) => {
    setApiStatus(undefined);
    setIsFilterLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}hr-approve-attendance-details?current_date=${monthValue}&EmployeeID=${employeeId}`
      );

      setApiStatus(response?.status);
      if (response?.status === 200) {
        // Attendance Months
        const attendanceMonths = response?.data?.days || [];
        setAttendanceMonths(attendanceMonths);

        // Attendance Data
        const attendanceData = response?.data?.data || [];
        setAttendanceData(attendanceData);

        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error making GET request", error);
    } finally {
      setIsFilterLoading(false);
    }
  };
  useEffect(() => {
    fetchAttendanceMonths();
  }, []);

  const fetchAttendanceMonths = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}hr-approve-attendance-details-list`
      );
      // Months options List
      const Months = response?.data?.month || "";
      const monthsOpt = Months?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setMonthsOpt(monthsOpt);
      setSelectedMonth(monthsOpt[0]);
      // Employee options List
      const Employee = response?.data?.employee;
      const EmpOpt = Employee?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setEmpOpt(EmpOpt);
    } catch (error) {
      console.error("Error making Post request", error);
    }
  };
  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("HR Attendance Approval"));
  }, []);

  const tableHeaders = Object.keys(attendanceMonths || {})
    .filter((key) => key !== "Name" && key !== "Action")
    .map((date) => date); // Keep the full date format

  const renderTableHeader = () => {
    if (tableHeaders.length === 0) {
      return (
        <th colSpan="2" style={{ textAlign: "center" }}>
          No Data Found
        </th>
      );
    }

    return (
      <>
        <th>Employee</th>
        {tableHeaders.map((date, index) => {
          const cleanedValue =
            attendanceMonths?.[date]?.replace(/<[^>]+>/g, "") || "";
          const charPart = cleanedValue.charAt(0) || ""; // First letter
          const numPart = cleanedValue.substring(1) || ""; // Remaining numbers

          return (
            <th key={index} className="text-center">
              <div>{charPart}</div>
              <div>{numPart}</div>
            </th>
          );
        })}
        <th>Action</th>
      </>
    );
  };

  const handleClick = (value, employeeName) => {
    if (value.startsWith("P") || value.startsWith("A_")) {
      const parts = value.split("_");
      const TXNID = parts[1];
      const LineNo = parts[2];

      setSelectedValue(value);
      setShowModal(true);
      setSelectedEmployeeName(employeeName);

      PostServiceCaller(`${API_URL}view-data`, { TXNID, LineNo }, "post")
        .then((response) => {
          const data = response?.data?.data;
          const modalDataWithStatus = data?.map((o) => ({
            ...o,
            daystatus: o.DayStatus ? o.DayStatus : 1,
          }));
          setModalData(modalDataWithStatus);

          // Initialize initialStatuses with the current statuses
          const initialStatusesObj = {};
          modalDataWithStatus.forEach((item, idx) => {
            initialStatusesObj[idx] = parseInt(item.daystatus);
          });
          setInitialStatuses(initialStatusesObj);

          // Initialize selectedStatus with the current statuses
          const selectedStatusObj = {};
          modalDataWithStatus.forEach((item, idx) => {
            selectedStatusObj[idx] = parseInt(item.daystatus);
          });
          setSelectedStatus(selectedStatusObj);
        })
        .catch((error) => {
          console.error("Error making Post request", error);
        });
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedValue(null);
    setRemarks([]);
    setRemarkErrors({});
  };
  const StatusOpt = [
    { value: 1, label: "Present" },
    { value: 0, label: "Absent" },
  ];

  const handleStatusChange = (value, index) => {
    // Update modalData
    setModalData((prev) => {
      const updatedData = [...prev];
      updatedData[index] = {
        ...updatedData[index],
        daystatus: value.value,
      };
      return updatedData;
    });

    // Update selectedStatus
    setSelectedStatus((prev) => ({
      ...prev,
      [index]: value.value,
    }));
  };

  const handleStatusSubmit = async (item, index) => {
    const status = selectedStatus[index];
    const initialStatus = initialStatuses[index];
    const remark = remarks[index] || "";

    // Validate status change
    if (status === undefined || status === null) {
      return toast.error("Please select a status");
    }

    if (status === initialStatus) {
      return toast.error("Please change the status before submitting");
    }
    if (!remark.trim()) {
      setRemarkErrors((prev) => ({
        ...prev,
        [index]: "Remark is required",
      }));
      return;
    }

    const payload = {
      daystatus: status,
      employeeID: item.EmployeeID,
      rowstatus: 436,
      attendancestatus: 826,
      dates: moment(item.date).format("YYYY-MM-DD"),
      MonthID: selectedMonth?.value,
      remark: remark,
    };

    try {
      const response = await PostFormServiceCaller(
        `${API_URL}disapprove-attendance`,
        payload
      );
      toast.success("Attendance status changed successfully!");
      fetchAttendanceDetails();
      setShowModal(false);
    } catch (error) {
      console.error("Error submitting data", error);
      toast.error("Failed to update attendance");
    }
  };
  const handleAttendanceApprove = (employee) => {
    setSelectedEmployee(employee);
    setShowApproval(true);
  };

  const handleApprove = () => {
    if (!selectedEmployee) {
      console.error("No employee selected.");
      return;
    }

    // Extract valid dates (excluding "WO" and "HOL")
    const validDates = Object.keys(selectedEmployee)
      .filter((key) => key.match(/^\d{2}-[A-Za-z]{3}-\d{4}$/)) // Matches date format
      .filter(
        (key) =>
          selectedEmployee[key] !== "WO" && selectedEmployee[key] !== "HOL"
      ); // Exclude "WO" & "HOL"

    const payload = {
      daystatus: 1.0,
      employeeID: selectedEmployee.id,
      rowstatus: 436,
      remark: document.getElementById("remark").value,
      attendancestatus: 826,
      dates: validDates.join(", "),
      MonthID: selectedMonth.value,
    };

    // API call
    PostFormServiceCaller(`${API_URL}manager-mark-attendance`, payload)
      .then((response) => {
        toast.success("Attendance Approve Sucessfully!");
        setShowApproval(false);
        fetchAttendanceDetails();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  // const handleGetData = () => {
  //   fetchAttendanceDetails(selectedMonth?.value, selectedEmp?.value);
  // };
  const handleGetData = () => {
    const month = selectedMonth?.value || monthsOpt[0]?.value;
    const empId = selectedEmp?.value || 0;
    setIsFilterLoading(true);
    fetchAttendanceDetails(month, empId);
  };

  useEffect(() => {
    if (monthsOpt.length > 0 && !selectedMonth) {
      setSelectedMonth(monthsOpt[0]);
    }
  }, [monthsOpt]);
  const handleReset = async () => {
    setSelectedEmployee(null);
    setSelectedEmp(null); // Also reset the selected employee dropdown
    await fetchAttendanceMonths(); // Wait for the data to be fetched

    // Use the state updater function to ensure we have the latest monthsOpt
    setSelectedMonth((prev) => {
      const firstMonth = monthsOpt[0];
      return firstMonth || null;
    });

    // Trigger a fresh data fetch with reset values
    fetchAttendanceDetails(monthsOpt[0]?.value, 0);
  };
  const getFormattedName = (name) => {
    const parts = name.trim().split(" ");
    const firstName = parts[0];
    const lastNameInitial =
      parts.length > 1 ? parts[parts.length - 1][0] + "." : "";
    return `${firstName} ${lastNameInitial}`;
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <div className="d-flex flex-column flex-md-row gap-2">
              <div className="col-md-2">
                <label for="leave-type" class="form-label">
                  Month
                </label>
                <Select
                  options={monthsOpt}
                  onChange={setSelectedMonth}
                  value={selectedMonth}
                />
              </div>

              <div className="col-md-2">
                <label for="leave-type" class="form-label">
                  Employee
                </label>
                <Select
                  options={empOpt}
                  onChange={setSelectedEmp}
                  value={selectedEmp}
                />
              </div>

              <div className="col-md-8 text-end mt-0 mt-md-4 px-md-3">
                <button className="custom-btn me-2" onClick={handleReset}>
                  Reset
                </button>
                <button className="custom-btn" onClick={handleGetData}>
                  Get Data
                </button>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <p>
                  <FaSpinner className="spinner" spin />
                  <br />
                  Loading
                </p>
              </div>
            ) : (
              <div className="container-fluid">
                <div style={{ overflowX: "auto" }}>
                  <Table striped bordered hover>
                    <thead id="thcolor" className="text-center">
                      <tr>{renderTableHeader()}</tr>
                    </thead>
                    <tbody>
                      {isLoading || isFilterLoading ? (
                        <tr>
                          <td
                            colSpan={tableHeaders.length + 2}
                            className="text-center"
                          >
                            <p>
                              <FaSpinner className="spinner" spin />
                              <br />
                              Loading
                            </p>
                          </td>
                        </tr>
                      ) : apiStatus === 200 && filteredData.length > 0 ? (
                        currentData.map(([key, employee]) => (
                          <tr key={key}>
                            <td>{employee.Name}</td>
                            {tableHeaders.map((date, index) => {
                              const cellValue = employee[date];
                              const workReq = employee.work_requests ? employee.work_requests[date] : null;
                              let cellClass = "";
                              let cellStyle = {};

                              if (
                                cellValue &&
                                cellValue.startsWith("P_") &&
                                cellValue.endsWith("_1")
                              ) {
                                // Approved Present (Gray)
                                cellStyle.color = "#616161";
                              } else if (
                                cellValue &&
                                cellValue.startsWith("A_") &&
                                cellValue.endsWith("_1")
                              ) {
                                // Approved Absent (Gray)
                                cellStyle.color = "#616161";
                              } else if (
                                cellValue &&
                                cellValue.startsWith("P_") &&
                                !cellValue.endsWith("_1")
                              ) {
                                // Pending Present (Black Bold)
                                cellClass = "fw-bold";
                                cellStyle.color = "#000000";
                              } else if (
                                cellValue &&
                                cellValue.startsWith("A_") &&
                                !cellValue.endsWith("_1")
                              ) {
                                // Pending Absent (Red Bold)
                                cellStyle.color = "#FF0000";
                                cellClass = "fw-bold";
                              }

                              const mainStatus = cellValue && cellValue.startsWith("P_")
                                ? "P"
                                : cellValue && cellValue.startsWith("A_")
                                  ? "A"
                                  : cellValue || "-";

                              return (
                                <td
                                  key={index}
                                  onClick={() => {
                                    // Only allow click if PayrollCalculated === 0 or undefined
                                    if (
                                      cellValue &&
                                      employee.PayrollCalculated !== 1
                                    ) {
                                      handleClick(cellValue, employee.Name);
                                    }
                                  }}
                                  className={`text-center ${cellClass}`}
                                  style={{
                                    cursor:
                                      employee.PayrollCalculated === 1
                                        ? "default"
                                        : cellValue
                                        ? "pointer"
                                        : "default",
                                    ...cellStyle,
                                    // Styling based on PayrollCalculated status
                                    color:
                                      employee.PayrollCalculated === 1
                                        ? "#999" // Gray if payroll processed (disabled)
                                        : cellValue?.startsWith("P_") ||
                                          cellValue?.startsWith("A_")
                                        ? "#07f03eff" // Green for "P" and "A"
                                        : cellStyle.color,
                                    fontWeight:
                                      employee.PayrollCalculated === 1
                                        ? "normal" // Normal if disabled
                                        : cellValue?.startsWith("P_") ||
                                          cellValue?.startsWith("A_")
                                        ? "bold" // Bold for "P" and "A"
                                        : "normal", // Normal for others
                                    ...cellStyle,
                                  }}
                                  title={
                                    employee.PayrollCalculated === 1
                                      ? "Payroll processed - cannot modify"
                                      : ""
                                  }
                                >
                                  {workReq ? (
                                    <div className="d-flex flex-column align-items-center justify-content-center py-0" style={{ lineHeight: "1.1" }}>
                                      <span>{mainStatus === "-" ? "P" : mainStatus}</span>
                                      <span
                                        className="fw-bold text-primary"
                                        style={{ fontSize: "9px", marginTop: "1px", lineHeight: "1" }}
                                      >
                                        {workReq}
                                      </span>
                                    </div>
                                  ) : (
                                    mainStatus
                                  )}
                                </td>
                              );
                            })}
                            <td className="text-center">
                              <i
                                className={`fa fa-check ${
                                  clicked ? "text-gray-500" : "text-gray-600"
                                }`}
                                style={{
                                  cursor: clicked ? "not-allowed" : "pointer",
                                  pointerEvents: clicked ? "none" : "auto",
                                  opacity: clicked ? 0.2 : 0.1,
                                }}
                                // onClick={() => {
                                //   if (!clicked) {
                                //     handleAttendanceApprove(employee);
                                //     setClicked(true);
                                //   }
                                // }}
                              ></i>
                            </td>
                          </tr>
                        ))
                      ) : apiStatus === 200 && filteredData.length === 0 ? (
                        <tr>
                          <td
                            colSpan={tableHeaders.length + 2}
                            className="text-center"
                          >
                            No Data Found
                          </td>
                        </tr>
                      ) : apiStatus === undefined &&
                        filteredData.length === 0 ? (
                        <tr>
                          <td
                            colSpan={tableHeaders.length + 2}
                            className="text-center"
                          >
                            <FaSpinner className="spinner" />
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td
                            colSpan={tableHeaders.length + 2}
                            className="text-center"
                          >
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
                {filteredData.length > 0 && (
                  <div className="d-flex justify-content-between mt-3">
                    <div>
                      <span className="d-flex align-items-center">
                        Showing {startIndex + 1} - {endIndex} of{" "}
                        {filteredData.length}{" "}
                        <select
                          value={selectedRecordsPerPage}
                          onChange={handleRecordsPerPage}
                          className="mx-2 form-select form-select-sm"
                          style={{ width: "auto" }}
                        >
                          {recordsPerPageOption.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </span>
                    </div>
                    <div>
                      <Pagination
                        itemsPerPage={selectedRecordsPerPage}
                        totalItems={filteredData.length}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            {showModal && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                  backdropFilter: "blur(2px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                  padding: "16px",
                }}
              >
                <div
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    width: "100%",
                    maxWidth: "450px",
                    boxShadow: "0 4px 24px rgba(0, 0, 0, 0.1)",
                    overflow: "hidden",
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "5px",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#333",
                        marginLeft: "10px",
                      }}
                    >
                      Edit Attendance ({selectedEmployeeName || ""})
                    </h3>
                    <button
                      onClick={handleClose}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: "20px",
                        color: "#999",
                        cursor: "pointer",
                        padding: "4px",
                        borderRadius: "4px",
                        transition: "all 0.2s",
                        ":hover": {
                          background: "#f5f5f5",
                          color: "#666",
                        },
                      }}
                    >
                      ✕
                    </button>
                  </div>

                  {/* Body */}
                  <div style={{ padding: "10px" }}>
                    {modalData && modalData.length > 0 ? (
                      modalData.map((item, index) => (
                        <div key={index} style={{ marginBottom: "5px" }}>
                          {/* Date */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "16px",
                            }}
                          >
                            <div
                              style={{
                                flex: "0 0 100px",
                                color: "#666",
                                fontSize: "14px",
                              }}
                            >
                              <strong>Date</strong>
                            </div>
                            <div
                              style={{
                                color: "#333",
                                fontWeight: "500",
                              }}
                            >
                              {moment(item.date).format("DD-MMM-YYYY")}
                            </div>
                          </div>

                          {/* Status */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "16px",
                            }}
                          >
                            <div
                              style={{
                                flex: "0 0 100px",
                                color: "#666",
                                fontSize: "14px",
                              }}
                            >
                              <strong>Status</strong>
                            </div>
                            <div style={{ flex: 1 }}>
                              <Select
                                options={StatusOpt}
                                value={StatusOpt?.find(
                                  (o) => o.value === parseInt(item.daystatus)
                                )}
                                onChange={(value) =>
                                  handleStatusChange(value, index)
                                }
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "40px",
                                    borderColor: "#e0e0e0",
                                    borderRadius: "8px",
                                    boxShadow: "none",
                                    ":hover": {
                                      borderColor: "#ccc",
                                    },
                                  }),
                                }}
                              />
                            </div>
                          </div>

                          {/* Remark */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              marginBottom: "5px",
                            }}
                          >
                            <div
                              style={{
                                flex: "0 0 100px",
                                color: "#666",
                                fontSize: "14px",
                                paddingTop: "10px",
                              }}
                            >
                              <strong>Remark</strong>
                              <span className="required">*</span>
                            </div>
                            <div style={{ flex: 1 }}>
                              <textarea
                                value={remarks[index] || ""}
                                onChange={(e) => {
                                  const newRemarks = [...remarks];
                                  newRemarks[index] = e.target.value;
                                  setRemarks(newRemarks);
                                  setRemarkErrors((prev) => ({
                                    ...prev,
                                    [index]: "",
                                  }));
                                }}
                                style={{
                                  width: "100%",
                                  minHeight: "80px",
                                  padding: "12px",
                                  border: remarkErrors[index]
                                    ? "1px solid red"
                                    : "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  resize: "vertical",
                                  fontSize: "14px",
                                }}
                              />
                              {remarkErrors[index] && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                  {remarkErrors[index]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Actions */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "12px",
                            }}
                          >
                            <button
                              onClick={handleClose}
                              className="cancel-btn"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => handleStatusSubmit(item, index)}
                              className="custom-btn"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          padding: "40px 20px",
                          textAlign: "center",
                          color: "#999",
                        }}
                      >
                        Loading attendance data...
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {/* Approve Attendance */}
            {showApproval && (
              <div
                className="modal"
                tabIndex="-1"
                role="dialog"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 1050,
                }}
              >
                <div
                  className="modal-dialog modal-sm"
                  role="document"
                  style={{
                    width: "300px", // Standard width for modal-sm
                    margin: 0, // Remove default margin
                  }}
                >
                  <div className="modal-content">
                    {/* <div className="modal-header d-flex justify-content-between">
                      <h6 className="heading skill-heading">
                        Approve Attendance
                      </h6>
                      <button
                        className="custom-btn"
                        onClick={() => setShowApproval(false)}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div> */}
                    <div
                      className="modal-header"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #f0f0f0",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px 8px 0 0",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#27568B",
                          margin: "0",
                        }}
                      >{`Approve Attendance (${getFormattedName(
                        selectedEmployee.Name
                      )})`}</p>
                      <button
                        onClick={() => setShowApproval(false)}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          fontSize: "18px",
                          color: "#000",
                          padding: "4px",
                          borderRadius: "4px",
                          transition: "all 0.2s",
                          lineHeight: "1",
                        }}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div>

                    <div className="modal-body p-2">
                      {selectedEmployee ? (
                        <>
                          <div className="row">
                            <div className="col-md-12">
                              <textarea
                                type="text"
                                className="form-control"
                                id="remark"
                                name="remark"
                                placeholder="Remark"
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <p>No data available</p>
                      )}
                    </div>
                    <div className="text-end p-2">
                      <button
                        type="button"
                        className="cancel-btn-sm me-2"
                        onClick={() => setShowApproval(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="custom-btn-sm"
                        onClick={handleApprove}
                      >
                        Approve
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HRAttendanceApproval;
